import React, { Component } from 'react';
import { Modal } from 'antd';
import AccountModalTitle from './accountModal/AccountModalTitle';

export default class AccountModal extends Component {
    constructor(props) { super(props); }
    render() {
        const
        { USER_DETAILS } = session.jwtSession,
        { state, services, children } = this.props,
        { showAccountsModal } = state;

        return (
            <div>
                <Modal
                    width={530}
                    footer={null}
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={showAccountsModal}
                    bodyStyle={{ padding: '15px' }}
                >
                    <AccountModalTitle closeEvent={services.toggleAccountModal} />
                    {children}
                </Modal>
            </div>
        )
    }
}
